<template>
  <div id="payment">
    <!-- 標題一 -->
    <v-title>
      <v-font font-text="步驟二：確認繳款項目明細" />
      <div class="spanfs mt-2">
        <v-font slot="etext" font-text="Step Two: Order Information" />
      </div>
    </v-title>
    <hr />
    <!-- 收費明細 -->
    <b-table
      hover
      small
      bordered
      stacked="md"
      show-empty
      empty-text="目前無資料"
      :items="items"
      :fields="fields"
    >
      <!-- 單價 -->
      <template v-slot:cell(FeeItemValue)="data">
        {{ data.item.FeeItemValue + ' 元' }}
      </template>
      <!-- 繳費金額 -->
      <template v-slot:cell(PayAmt)="data">
        {{ data.item.PayAmt + ' 元' }}
      </template>
      <!-- 功能 -->
      <template v-slot:cell(Action)="data">
        <!-- 刪除 -->
        <v-button
          class="lh-fs"
          title="刪除"
          btn-text="刪除"
          btn-type="danger"
          @click.native="ShowDeleData(data.item)"
        >
          <br slot="eg" />
          <v-font slot="icon" font-css="spanfss" font-text="Delete" />
        </v-button>
      </template>
      <!-- 總金額 -->
      <template v-slot:table-caption>
        <span class="word-bold text-size ml-2" style="color: darkslategray;">
          總金額
          <span class="spanfs">
            (Total Amount)
          </span>
          ：{{ DocTotalAmt }}元
        </span>
      </template>
    </b-table>
    <br />
    <!-- 標題二 -->
    <v-title v-if="PaymentType">
      <v-font font-text="步驟三：選擇繳費方式" />
      <div class="spanfs mt-2">
        <v-font slot="etext" font-text="Step Three: Choose Payment Method" />
      </div>
    </v-title>
    <hr />
    <!-- 繳費管道 -->
    <div v-if="PaymentType" class="row ml-4">
      <!-- web -->
      <div class="card-deck web-on mb-4" style="margin:0px auto;">
        <div class="card-group">
          <v-card
            v-if="itemslength == ArrTest[0]"
            class="mr-2 credit word-bold"
            card-img="1"
            cardFontText="國內信用卡"
            cardFontEgText="Credit Card (Taiwan)"
            @click.native="PostFeeorderShopcheck('1')"
          >
            <br slot="cardbr" />
            <a
              slot="link"
              class="spanfss"
              target="_blank"
              href="https://www.nccc.com.tw/wps/wcm/connect/9b091a34-a6e7-4dfe-9c02-2e36ef5c9449/%E5%85%AC%E5%8B%99%E6%A9%9F%E9%97%9C%E7%B9%B3%E8%B2%BB%E5%B9%B3%E5%8F%B0_%E6%96%87%E5%AE%A31080901%E7%94%9F%E6%95%88.pdf?MOD=AJPERES&CACHEID=ROOTWORKSPACE-9b091a34-a6e7-4dfe-9c02-2e36ef5c9449-mSkEz2B"
              rel="noopener noreferrer"
            >
              (點我查看合作銀行)
            </a>
          </v-card>
          <v-card
            v-if="itemslength == ArrTest[1]"
            class="mr-2 credit word-bold"
            card-img="2"
            cardFontText="國外信用卡"
            cardFontEgText="Credit Card (International)"
            @click.native="PostFeeorderShopcheck('2')"
          />
          <v-card
            v-if="itemslength == ArrTest[2]"
            class="mr-2 word-bold ipass"
            card-img="3"
            cardFontText="一卡通"
            cardFontEgText="iPASS Card"
          />
          <v-card
            v-if="itemslength == ArrTest[3]"
            class="mr-2 credit word-bold"
            card-img="4"
            card-img-css="imgline"
            cardFontText="LINE Pay"
            @click.native="PostFeeorderShopcheck('4')"
          >
          </v-card>
          <v-card
            v-if="itemslength == ArrTest[4]"
            class="mr-2 credit word-bold"
            card-img="5"
            cardFontText="繳費單(含超商)"
            cardFontEgText="Print Bill (Including Convenience Store)"
            @click.native="PostFeeorderShopcheck('6')"
          />
          <v-card
            v-if="itemslength == ArrTest[5]"
            class="credit word-bold"
            card-img="6"
            cardFontText="繳費單(不含超商)"
            cardFontEgText="Print Bill (Not for Convenience Store)"
            @click.native="PostFeeorderShopcheck('7')"
          />
        </div>
      </div>

      <!-- 增加 label 與 id -->
      <label for="paymentMethodSelect" class="sr-only">繳費方式 Pay Method</label>

      <!-- mobile -->
      <select
        id="paymentMethodSelect"
        class="mr-2 ml-2 mb-4 form-control mobile"
        v-model="Payment"
        @change="SelectCheckData"
      >
        <option value="0" selected>
          --- 繳費
          <span class="spanfs">
            Pay
          </span>
          ---
        </option>
        <option v-if="itemslength == ArrTest[0]" value="1">
          國內信用卡
          <span class="spanfs">
            Credit Card - Taiwan
          </span>
        </option>
        <option v-if="itemslength == ArrTest[1]" value="2">
          國外信用卡
          <span class="spanfs">
            Credit Card - International
          </span>
        </option>
        <option v-if="itemslength == ArrTest[2]" value="3">
          一卡通
        </option>
        <option v-if="itemslength == ArrTest[3]" value="4">
          LINE Pay
        </option>
        <option v-if="itemslength == ArrTest[4]" value="6">
          繳費單(含超商)
          <span class="spanfs">
            Print Bill - Including Convenience Store
          </span>
        </option>
        <option v-if="itemslength == ArrTest[5]" value="7">
          繳費單(不含超商)
          <span class="spanfs">
            Print Bill - Not for Convenience Store
          </span>
        </option>
      </select>
      <!-- 國內支援銀行連結 -->
      <a
        class="mobile ml-3 mb-4"
        href="https://www.nccc.com.tw/creditcard/"
        target="_blank"
        rel="noopener noreferrer"
      >
        *國內信用卡-多家銀行
      </a>
    </div>
    <!-- Modal 確認基本資料 -->
    <v-modal id="CheckUserData">
      <div slot="header">
        <v-label :lab-text="modaltext + '- 確認填寫資料'">
          <v-font slot="small" font-css="spanfs" :font-text="modaletexts + ',Check Data'" />
        </v-label>
      </div>
      <div slot="body">
        <div class="form-row">
          <div class="form-group col-md-6">
            <v-font font-text="帳號" forId="UserAccount">
              <v-font slot="text" font-css="spanfss" font-text="(UserId)" />
            </v-font>
            <input
              id="UserAccount"
              class="form-control"
              type="text"
              v-model="UserData.UserId"
              readonly
            />
          </div>
          <div class="form-group col-md-6">
            <v-small />
            <v-font font-text="繳款人名稱" forId="UserNameInput">
              <v-font slot="text" font-css="spanfss" font-text="(UserName)" />
            </v-font>
            <input
              id="UserNameInput"
              class="form-control nukWord"
              type="text"
              placeholder="請填寫您的大名"
              v-model="UserData.UserName"
              required
            />
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-6">
            <v-small />
            <v-font font-text="聯絡信箱" forId="email">
              <v-font slot="text" font-css="spanfss" font-text="(Email)" />
            </v-font>
            <input
              id="email"
              class="form-control"
              type="email"
              placeholder="請填寫您的信箱"
              v-model="UserData.Email"
              required
            />
          </div>
          <div class="form-group col-md-6">
            <v-small />
            <v-font font-text="聯絡電話" forId="phone">
              <v-font slot="text" font-css="spanfss" font-text="(Phone)" />
            </v-font>
            <input
              id="phone"
              class="form-control"
              type="tel"
              placeholder="請填寫您的電話"
              v-model="UserData.Telephone"
              required
            />
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-6">
            <v-font font-text="收據抬頭" forId="receiptTitle">
              <v-font slot="text" font-css="spanfss" font-text="(Receipt Title)" />
            </v-font>
            <input
              id="receiptTitle"
              class="form-control nukWord"
              type="text"
              v-model="ReceiptTitle"
              placeholder="請輸入收據抬頭"
              required
            />
            <input
              id="sas"
              class="form-check-input ml-1"
              type="checkbox"
              v-model="UserName"
              :true-value="1"
              :false-value="2"
              @click="CheckReceipt"
            />
            <v-label for="sas" lab-text="同繳款人名稱(with User name)" class="ssw spanfs" />
            <input
              id="sass"
              class="form-check-input ml-1"
              style="display: block;"
              type="checkbox"
              :true-value="1"
              :false-value="0"
              v-model="UserData.NeedReceipt"
            />
            <v-label for="sass" lab-text="需要收據請勾選(請至出納組領取)" class="ssw spanfs" />
          </div>
          <div class="form-group col-md-6">
            <v-font font-text="公司統編" forId="companyId">
              <v-font slot="text" font-css="spanfss" font-text="(Company ID Number)" />
            </v-font>
            <input
              id="companyId"
              class="form-control"
              type="tel"
              placeholder="請輸入公司統編"
              v-model="UserData.Unino"
              required
            />
          </div>
        </div>
        <div class="form-row">
          <!-- 信用卡 -->
          <div v-if="CheckUser" class="form-group col-md-12">
            <label for="user_gui_number">
              <v-small />
              身份證字號
              <span style="color:red;">
                (英文字母為大寫)
              </span>
              /公司統編
            </label>
            <input
              class="form-control"
              type="text"
              placeholder="請輸入身份證字號(英文字母為大寫)/公司統編"
              v-model="PID"
              required
            />
            <span>
              因本系統屬
              <span class="checkpay">「公務機構特店」</span>
              ，若使用信用卡付款，<br />
              須依您所預計使用的信用卡身份，請輸入對應的資訊。<br />
              若屬
              <span class="checkpay">個人使用</span>
              ，請輸入
              <span class="checkpay">信用卡持有者之身份証字號</span>
              ;<br />
              若屬
              <span class="checkpay">公司行號所有</span>
              ，則輸入
              <span class="checkpay">公司統一編號</span>，
              <br />
              輸入資訊僅供
              <span class="checkpay">「聯合信用卡處理中心」</span>
              使用，本系統不予紀錄。<br />
            </span>
          </div>
        </div>
      </div>
      <div slot="footer">
        <v-button class="lh-fs" btn-text="取消" btn-type="secondary" data-dismiss="modal">
          <span slot="eg" class="spanfs"> <br />Close </span>
        </v-button>
        <v-button class="lh-fs ml-2" btn-text="確認" btn-type="primary" @click.native="CheckData">
          <span slot="eg" class="spanfs"> <br />Confirm </span>
        </v-button>
      </div>
    </v-modal>
    <!-- Modal 確認刪除資料 -->
    <v-modal id="DeleCheckout">
      <div slot="header">
        刪除繳費項目
      </div>
      <div slot="body">確認是否刪除「{{ DeleDatas.FeeItemName }}」項目?</div>
      <div slot="footer">
        <v-button class="lh-fs" btn-text="取消" btn-type="secondary" data-dismiss="modal">
          <span slot="eg" class="spanfs"> <br />Close </span>
        </v-button>
        <v-button
          class="lh-fs ml-2"
          btn-text="刪除"
          btn-type="danger"
          @click.native="PostFeeorderShopdel"
        >
          <span slot="eg" class="spanfss"> <br />Delete </span>
        </v-button>
      </div>
    </v-modal>
  </div>
</template>

<script>
import vCard from '@/components/Features/Card'
import vSmall from '@/components/Features/Small'
import vModal from '@/components/Features/ModalFloot'
import {
  apiFeeorderShopquery,
  apiFeeorderShopdel,
  apiFeeorderPrintgen,
  apiAccountQuery,
  apiLinePay,
  apiGettxnauth,
  apiFeeorderShopcheck,
  apiAccountModify
} from '../../Api/api'
import $ from 'jquery'
export default {
  components: {
    vCard,
    vSmall,
    vModal
  },
  name: 'payment',
  data () {
    return {
      fields: [
        {
          key: 'SerialNo',
          label: '#',
          thClass: 'table-th',
          class: 'table-mini',
          sortable: true
        },
        {
          key: 'FeeItemName',
          label: '收費項目名稱\nFee Item Name',
          thClass: 'table-th',
          class: 'table-long'
        },
        {
          key: 'FeeOrderDesc',
          label: '繳款項目說明事由\nDescription',
          thClass: 'table-th',
          class: 'table-long'
        },
        { key: 'FeeItemValue', label: '單價\nUnit Price', thClass: 'table-th' },
        { key: 'FeeItemCount', label: '數量\nQuantity', thClass: 'table-th' },
        {
          key: 'PayAmt',
          label: '繳費金額\nAmount',
          thClass: 'table-th',
          variant: 'warning',
          sortable: true
        },
        { key: 'Action', label: '功能\nAction', thClass: 'table-th' }
      ],
      items: [],
      Print: [],
      ArrTest: [],
      UserData: {},
      PID: '',
      DeleDatas: '',
      modaltext: '',
      modaletexts: '',
      CheckoutData: '',
      ReceiptTitle: '',
      confirmUrl: '',
      cancelUrl: '',
      Payment: '0',
      itemslength: 0,
      NeedReceipt: 0,
      DocTotalAmt: 0,
      UserName: false,
      CheckUser: false,
      PaymentType: false
    }
  },
  mounted () {
    this.PostFeeorderShopquery()
  },
  methods: {
    // 此頁面API依數字流程跑
    PostFeeorderShopquery () {
      // 1-查詢購物車 F_API 011
      // 定義資料
      const vm = this
      const NewData = JSON.parse(localStorage.getItem('M_Identity'))
      // 呼叫API
      apiFeeorderShopquery(NewData).then(res => {
        if (res !== undefined) {
          vm.PaymentType = true
          for (let i = 0; i < res.Data.length; i++) {
            // 遍歷GET data
            const json = res.Data[i] // 添增Count屬性
            json.SerialNo = i + 1
          }
          vm.items = res.Data
          vm.CountAllAmt()
        } else {
          $('#CheckError').modal('show')
          vm.$router.push('/feeorder/personal')
        }
      })
    },
    CountAllAmt () {
      // 2-計算總金額
      const vm = this
      vm.DocTotalAmt = 0
      for (let i = 0; i < vm.items.length; i++) {
        const Amt = vm.items[i]
        vm.DocTotalAmt += Amt.PayAmt
      }
      vm.CheckPayCategory()
    },
    CheckPayCategory () {
      // 3-繳費種類
      const vm = this
      vm.ArrTest = [0, 0, 0, 0, 0, 0, 0, 0]
      vm.itemslength = vm.items.length // 購物車數量
      for (let i = 0; i < vm.itemslength; i++) {
        // 十進位轉換二進位
        let p = null
        let a1 = null
        let b1 = null
        let num2 = null
        const num1 = vm.items[i].PayCategory // 繳費通路
        const currnum = 128
        // num1 二進位轉換
        if (num1 >= currnum) {
          num2 = '1'
          a1 = num1 - currnum
          b1 = currnum / 2
        } else {
          num2 = '0'
          a1 = num1
          b1 = currnum / 2
        }
        for (p = 1; p <= 7; p++) {
          if (a1 >= b1) {
            num2 = num2 + '1'
            a1 = a1 - b1
            b1 = b1 / 2
          } else {
            num2 = num2 + '0'
            b1 = b1 / 2
          }
        }
        // 切割num2字串，加總繳費管道數量
        vm.ArrTest[0] += parseInt(num2.slice(7, 8))
        vm.ArrTest[1] += parseInt(num2.slice(6, 7))
        vm.ArrTest[2] += parseInt(num2.slice(5, 6))
        vm.ArrTest[3] += parseInt(num2.slice(4, 5))
        vm.ArrTest[4] += parseInt(num2.slice(3, 4))
        vm.ArrTest[5] += parseInt(num2.slice(2, 3))
        vm.ArrTest[6] += parseInt(num2.slice(1, 2))
        vm.ArrTest[7] += parseInt(num2.slice(0, 1))
      }
      // ArrTest 比對 itemslength，起碼要有一組有相符的數量
      if (vm.ArrTest.indexOf(vm.itemslength) === -1) {
        vm.$bus.$emit('Modals', '沒有相同的繳費方式，請刪除不相同繳費方式的項目。')
        $('#CheckError').modal('show')
        return false
      }
    },
    ShowDeleData (data) {
      // 4.1-呼叫購物車刪除modal
      this.DeleDatas = {
        FeeOrderId: data.FeeOrderId,
        FeeItemName: data.FeeItemName
      }
      $('#DeleCheckout').modal('show')
    },
    PostFeeorderShopdel () {
      // 4.2-購物車刪除項目 F_API 010
      const vm = this
      // 關閉Modal
      $('#DeleCheckout').modal('hide')
      // 定義資料
      const Identity = JSON.parse(localStorage.getItem('M_Identity'))
      const DelData = Object.assign(Identity, vm.DeleDatas)
      delete DelData.FeeItemName
      // 呼叫API
      apiFeeorderShopdel(DelData).then(res => {
        if (res !== undefined) {
          vm.DeleDatas = {}
          vm.PostFeeorderShopquery()
        }
      })
    },
    SelectCheckData () {
      // 5.1-mobile繳費方式
      const vm = this
      const data = vm.Payment
      if (data === '3') {
        vm.$bus.$emit('Modals', '一卡通繳費請至繳費機繳費。')
        $('#CheckError').modal('show')
        return false
      } else if (data === '0') {
        return false
      }
      vm.PostFeeorderShopcheck(data)
    },
    PostFeeorderShopcheck (data) {
      // 5.2-繳費前，檢查項目是否過期，error code = 0，才進行繳費。
      // 定義資料
      const vm = this
      var PayType = data
      vm.CheckUser = false
      switch (PayType) {
        case '1':
          PayType = 1
          vm.modaltext = '國內信用卡'
          vm.modaletexts = 'Credit Card (Taiwan)'
          vm.CheckUser = true
          break
        case '2':
          PayType = 2
          vm.modaltext = '國外信用卡'
          vm.modaletexts = 'Credit Card (International)'
          break
        case '4':
          PayType = 4
          vm.modaltext = 'LINE Pay'
          vm.modaletexts = 'LINE Pay'
          break
        case '6':
          PayType = 255
          vm.modaltext = '繳費單(含超商)'
          vm.modaletexts = 'Print Bill (Including Convenience Store)'
          break
        case '7':
          PayType = 254
          vm.modaltext = '繳費單(不含超商)'
          vm.modaletexts = 'Print Bill (Not for Convenience Store)'
          break
        default:
          vm.$bus.$emit('Modals', '繳費方式錯誤。')
          $('#CheckError').modal('show')
          return false
      }
      const NewData = JSON.parse(localStorage.getItem('M_Identity'))
      const PayData = []
      for (let i = 0; i < vm.items.length; i++) {
        const Data = {}
        Data.FeeOrderId = vm.items[i].FeeOrderId
        Data.PayAmt = vm.items[i].PayAmt
        PayData[i] = Data
      }
      NewData.Data = PayData
      NewData.PayType = PayType
      NewData.TotalAmt = vm.DocTotalAmt
      // 呼叫API
      apiFeeorderShopcheck(NewData).then(res => {
        if (res !== undefined) {
          vm.PostAccountQuery(data)
        }
      })
    },
    CheckReceipt () {
      // 6.1-同繳款人名稱
      const vm = this
      if (vm.UserName === 1) {
        vm.ReceiptTitle = ''
      } else {
        vm.ReceiptTitle = vm.UserData.UserName
      }
    },
    PostAccountQuery (data) {
      // 6.2-確認結帳基本資料，查詢UserData F_API 003
      this.Payment = data
      $('#CheckUserData').modal('show')
      // 定義資料
      const Identity = JSON.parse(localStorage.getItem('M_Identity'))
      delete Identity.ApplyDeptId
      // 呼叫API
      apiAccountQuery(Identity).then(res => {
        if (res !== undefined) {
          this.UserData = res
        } else {
          $('#CheckError').modal('show')
        }
      })
    },
    CheckData () {
      // 7.1寫入基本資料 F_API 004
      const vm = this
      const UpUserData = JSON.parse(localStorage.getItem('M_Identity'))
      // 確認資料寫入 F_API 004
      UpUserData.UserName = vm.UserData.UserName
      UpUserData.Email = vm.UserData.Email
      UpUserData.Telephone = vm.UserData.Telephone
      UpUserData.Address = vm.UserData.Address
      UpUserData.Unino = vm.UserData.Unino
      UpUserData.NeedReceipt = vm.UserData.NeedReceipt
      if (UpUserData.UserName === '') {
        vm.$bus.$emit('Modals', '繳款人名稱為必填欄位。')
        $('#CheckUserData').modal('hide')
        $('#CheckError').modal('show')
        return false
      }
      if (UpUserData.Email === '') {
        $('#CheckUserData').modal('hide')
        vm.$bus.$emit('Modals', '聯絡信箱為必填欄位。')
        $('#CheckError').modal('show')
        return false
      }
      if (UpUserData.Telephone === '') {
        $('#CheckUserData').modal('hide')
        vm.$bus.$emit('Modals', '聯絡電話為必填欄位。')
        $('#CheckError').modal('show')
        return false
      }
      apiAccountModify(UpUserData).then(res => {
        if (res !== undefined) {
          vm.CheckType()
        } else {
          vm.$bus.$emit('Modals', '填寫資料錯誤!')
          $('#CheckError').modal('show')
          return false
        }
      })
    },
    CheckType () {
      // 7.2判斷繳費方式
      const vm = this
      const PayUserData = {}
      PayUserData.UserName = vm.UserData.UserName
      PayUserData.Email = vm.UserData.Email
      PayUserData.Telephone = vm.UserData.Telephone
      PayUserData.ReceiptTitle = vm.ReceiptTitle
      PayUserData.Unino = vm.UserData.Unino
      PayUserData.NeedReceipt = vm.UserData.NeedReceipt
      localStorage.setItem('PayUserData', JSON.stringify(PayUserData))
      const CheckType = vm.Payment
      $('#CheckUserData').modal('hide')
      switch (CheckType) {
        case '1':
          vm.PostGettxnauth()
          break
        case '2':
          vm.PostGettxnauth()
          break
        case '4':
          vm.PostLinePay()
          break
        case '6':
          vm.PostFeeorderPrintgen()
          break
        case '7':
          vm.PostFeeorderPrintgenNoBarCode()
          break
        default:
          break
      }
    },
    PostGettxnauth () {
      // 8.1-國內外信用卡付款
      // 定義交易資料
      const vm = this
      const PayData = []
      var NotifyURL
      if (window.g.APIServeIP === 'http://10.201.86.159') {
        NotifyURL = window.g.APIServeIP + ':' + window.g.Dport + '/#/endcard/'
      } else if (window.g.Dport === '85') {
        NotifyURL = window.g.APIServeIP + ':' + window.g.Dport + '/#/endcard/'
      } else {
        NotifyURL = window.g.APIServeIP + '/#/endcard/'
      }
      for (let i = 0; i < vm.items.length; i++) {
        const Data = {}
        Data.FeeOrderId = vm.items[i].FeeOrderId
        Data.PayAmt = vm.items[i].PayAmt
        PayData[i] = Data
      }
      const CardData = JSON.parse(localStorage.getItem('M_Identity'))
      delete CardData.Token
      CardData.IntegratedSysId = '255' // 255: 多元繳費系統網頁
      CardData.Token = '9C2D3D654D8E495DBA5E38A0F8E20A32'
      CardData.TransMode = 0 // 0:一般交易
      CardData.TransAmt = vm.DocTotalAmt // 交易金額
      CardData.NotifyURL = NotifyURL
      CardData.Installment = 0 // 分期期數，本案預設為0
      CardData.Data = PayData
      if (vm.Payment === '1') {
        CardData.IsForeign = 1 // 國內
        if (vm.PID === '') {
          vm.$bus.$emit('Modals', '請輸入信用卡身分認證。')
          $('#CheckError').modal('show')
          return false
        }
        CardData.PID = vm.PID
      } else {
        CardData.IsForeign = 2 // 國外
      }
      // 呼叫API
      apiGettxnauth(CardData).then(res => {
        if (res !== undefined) {
          sessionStorage.setItem('CardType', vm.Payment) // vuex
          // 定義信用卡成功資料
          const CardOK = {}
          // 判斷國內外信用卡
          if (vm.Payment === '1') {
            CardOK.PayType = 1
          } else {
            CardOK.PayType = 2
          }
          CardOK.PayOrderId = res.CreditCardOrderId
          CardOK.TotalAmt = vm.DocTotalAmt
          CardOK.Data = []
          for (let i = 0; i < vm.items.length; i++) {
            CardOK.Data[i] = {}
            CardOK.Data[i].FeeOrderId = vm.items[i].FeeOrderId
            CardOK.Data[i].PayAmt = vm.items[i].PayAmt
          }
          sessionStorage.setItem('CardOK', JSON.stringify(CardOK)) // vuex
          document.location.href = res.ConfirmURL
        }
      })
    },
    PostLinePay () {
      // 8.2-LinePay 付款API
      // 定義資料
      const vm = this
      const PayData = []
      vm.confirmUrl = ''
      vm.cancelUrl = ''
      if (window.g.APIServeIP === 'http://10.201.86.159' || window.g.Dport === '85') {
        vm.confirmUrl = window.g.APIServeIP + ':' + window.g.Dport + '/#/endpayment/'
        vm.cancelUrl = window.g.APIServeIP + ':' + window.g.Dport + '/#/payment'
      } else {
        vm.confirmUrl = window.g.APIServeIP + '/#/endpayment/'
        vm.cancelUrl = window.g.APIServeIP + '/#/payment'
      }
      for (let i = 0; i < vm.items.length; i++) {
        const Data = {}
        Data.FeeOrderId = vm.items[i].FeeOrderId
        Data.PayAmt = vm.items[i].PayAmt
        PayData[i] = Data
      }
      const NewDatas = JSON.parse(localStorage.getItem('M_Identity'))
      delete NewDatas.UserId
      delete NewDatas.Token
      NewDatas.IntegratedSysId = '255'
      NewDatas.Token = '9C2D3D654D8E495DBA5E38A0F8E20A32'
      NewDatas.amount = vm.DocTotalAmt
      NewDatas.confirmUrl = vm.confirmUrl // 付款確認通知網址
      NewDatas.cancelUrl = vm.cancelUrl
      NewDatas.Data = PayData
      // 呼叫API
      apiLinePay(NewDatas).then(res => {
        if (res !== undefined) {
          // 定義LinrPay成功資料
          const Linepay = {}
          Linepay.PayType = 4
          Linepay.transactionId = res.info.transactionIdStr // LinePay 交易代碼
          Linepay.PayOrderId = res.PayOrderId
          Linepay.TotalAmt = vm.DocTotalAmt
          Linepay.Data = []
          for (let i = 0; i < vm.items.length; i++) {
            Linepay.Data[i] = {}
            Linepay.Data[i].FeeOrderId = vm.items[i].FeeOrderId
            Linepay.Data[i].PayAmt = vm.items[i].PayAmt
          }
          localStorage.setItem('Linepay', JSON.stringify(Linepay)) // vuex
          document.location.href = res.info.paymentUrl.web // 導向LinePay結帳頁面
        }
      })
    },
    PostFeeorderPrintgen () {
      // 8.3-列印(條碼)繳費單
      // 定義資料
      const vm = this
      const PrintData = JSON.parse(localStorage.getItem('M_Identity'))
      PrintData.PayType = '255' // 有條碼
      PrintData.TotalAmt = vm.DocTotalAmt // 總金額
      PrintData.Data = []
      for (let i = 0; i < vm.items.length; i++) {
        PrintData.Data[i] = {}
        PrintData.Data[i].FeeOrderId = vm.items[i].FeeOrderId
        PrintData.Data[i].PayAmt = vm.items[i].PayAmt
      }
      // 呼叫API
      apiFeeorderPrintgen(PrintData).then(res => {
        if (res !== undefined) {
          const FileName = res.FileName
          localStorage.setItem('Filepdf', FileName)
          // 定義繳費單成功資料
          const Shoppay = {}
          Shoppay.PayType = 255
          Shoppay.PayOrderId = res.PayOrderId // 繳費單號
          Shoppay.PrintDT = res.PrintDT
          Shoppay.PrintBarcode1 = res.PrintBarcode1
          Shoppay.PrintBarcode2 = res.PrintBarcode2
          Shoppay.PrintBarcode3 = res.PrintBarcode3
          Shoppay.PrintDebtNo = res.PrintDebtNo
          Shoppay.TotalAmt = PrintData.TotalAmt
          Shoppay.Data = PrintData.Data
          localStorage.setItem('Shoppay', JSON.stringify(Shoppay))
          vm.$router.push({ name: 'Home_Printgen' })
        }
      })
    },
    PostFeeorderPrintgenNoBarCode () {
      // 8.4-列印(無條碼)繳費單
      // 定義資料
      const vm = this
      const PrintDatas = JSON.parse(localStorage.getItem('M_Identity'))
      PrintDatas.PayType = '254' // 無條碼
      PrintDatas.TotalAmt = vm.DocTotalAmt // 總金額
      PrintDatas.Data = []
      for (let i = 0; i < vm.items.length; i++) {
        PrintDatas.Data[i] = {}
        PrintDatas.Data[i].FeeOrderId = vm.items[i].FeeOrderId
        PrintDatas.Data[i].PayAmt = vm.items[i].PayAmt
      }
      // 呼叫API
      apiFeeorderPrintgen(PrintDatas).then(res => {
        if (res !== undefined) {
          const FileName = res.FileName
          localStorage.setItem('Filepdf', FileName) // vuex
          // 定義繳費單成功資料
          const Shoppay = {}
          Shoppay.PayType = 254
          Shoppay.PayOrderId = res.PayOrderId // 繳費單號
          Shoppay.PrintDT = res.PrintDT
          Shoppay.PrintBarcode1 = res.PrintBarcode1
          Shoppay.PrintBarcode2 = res.PrintBarcode2
          Shoppay.PrintBarcode3 = res.PrintBarcode3
          Shoppay.PrintDebtNo = res.PrintDebtNo
          Shoppay.TotalAmt = PrintDatas.TotalAmt
          Shoppay.Data = PrintDatas.Data
          localStorage.setItem('Shoppay', JSON.stringify(Shoppay)) // vuex
          vm.$router.push({ name: 'Home_Printgen' })
        }
      })
    }
  }
}
</script>

<style lang="scss">
@import '../../assets/menu.scss';
// 國內信用卡
.ssw {
  margin-left: 1.2rem !important;
}
.checkpay {
  font-weight: bold;
  color: blue;
}
.ipass {
  position: relative; /*一卡通圖檔區域相對定位*/
}
.ipass:hover::before {
  /* 一卡通圖檔區域偽元素特效 */
  content: '請至繳費機繳費'; /*產生一個空的元素*/
  position: absolute; /*利用absolute定位*/
  left: 1px; /*調整位置*/
  right: -2px;
  border-radius: 0.25rem;
  width: 177px;
  height: 132px;
  font-size: 1.25rem;
  background-color: rgba(255, 212, 91, 0.7803921568627451);
  color: #000;
  text-shadow: 1px 1px #fff;
  line-height: 6;
}
.credit {
  position: relative; /*一卡通圖檔區域相對定位*/
}
.credit:hover::before {
  /* 一卡通圖檔區域偽元素特效 */
  content: '點擊繳費(Pay)'; /*產生一個空的元素*/
  position: absolute; /*利用absolute定位*/
  left: 1px; /*調整位置*/
  right: -2px;
  border-radius: 0.25rem;
  width: 177px;
  height: 132px;
  font-size: 1.25rem;
  background-color: rgba(255, 212, 91, 0.7803921568627451);
  color: #000;
  text-shadow: 1px 1px #fff;
  line-height: 6;
}
</style>
